import styled from "styled-components";
import { motion } from "framer-motion";

export const MapContainer = styled(motion.div).attrs({ className: "w-70" })`
  position: absolute;
  top: 5vmin;
  bottom: 0;
  left: 0;
`;

export const MapSidebar = styled(motion.div).attrs({
  className: "w-30 bg-black white vh-100 absolute dib ph4",
})`
  z-index: 1 !important;
  top: 5vmin;
  right: 0;
`;
